(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-flash-sale"] && !Shopify.designMode) return;
  try {
    
(() => {
  const updateHalloween = () => {
    const now = Date.now();
    document.querySelectorAll('[data-halloween-countdown]').forEach(timer => {
      const secondsLeft = Math.max(0, Math.ceil((Number(timer.dataset.halloweenCountdown) - now) / 1000));
      const hours = Math.floor(secondsLeft / 3600);
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;
      timer.querySelector('[data-countdown-hours]').textContent = String(hours).padStart(2, '0');
      timer.querySelector('[data-countdown-minutes]').textContent = String(minutes).padStart(2, '0');
      timer.querySelector('[data-countdown-seconds]').textContent = String(seconds).padStart(2, '0');
      timer.setAttribute('aria-label', `Sale ends in ${hours} hours, ${minutes} minutes and ${seconds} seconds`);
      timer.hidden = secondsLeft === 0;
    });
    document.querySelectorAll('[data-halloween-expiry]').forEach(element => {
      if (now >= Number(element.dataset.halloweenExpiry)) {
        const wrapper = element.closest('.shopify-section');
        (wrapper || element).hidden = true;
      }
    });
  };
  updateHalloween();
  setInterval(updateHalloween, 1000);
  document.addEventListener('shopify:section:load', updateHalloween);
  document.addEventListener('visibilitychange', updateHalloween);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
